import { Close } from "@mui/icons-material";
import { Dialog, Slide, Box, IconButton } from "@mui/material";
import { TransitionProps } from '@mui/material/transitions';
import React, { useRef } from "react";

// Slide-Animation von unten nach oben
const SlideUpTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Swipeable Dialog Component
export const CustomMobileDialog = ({ 
  children, 
  open, 
  onClose, 
  title,
}: { 
  children: React.ReactNode, 
  open: boolean, 
  onClose: () => void, 
  title: string,
}) => {
  const paperRef = useRef<HTMLDivElement>(null);
  const backdropRef = useRef<HTMLDivElement>(null);
  

  // Animation for closing the dialog
  const animateClose = () => {
    
    if (paperRef.current) {
      // Animate to slide down
      paperRef.current.style.transform = 'translateY(100%)';
    }
    
    if (backdropRef.current) {
      // Fade out backdrop
      backdropRef.current.style.opacity = '0';
    }
    
    // Delay actual closing to allow animation to complete
    setTimeout(() => {
      onClose();
    }, 300);
  };


  return (
    <Dialog
      open={open}
      onClose={animateClose}
      fullWidth
      maxWidth={false}
      TransitionComponent={SlideUpTransition}
      TransitionProps={{
        mountOnEnter: true,
        unmountOnExit: true,
      }}
      PaperProps={{
        style: {
          position: 'fixed',
          top:'3rem',
          left: 0,
          right: 0,
          height: 'calc(100% - 3rem)',
          margin: 0,
          width: '100%',
          maxWidth: '100%',
          maxHeight: 'none',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          transition: 'transform 0.3s ease-out',
        },
        ref: paperRef,
      }}
      sx={{
        '& .MuiDialog-container': {
          maxWidth: '100%',
          width: '100%',
          margin: 0
        },
        '& .MuiDialog-paper': {
          maxWidth: '100%',
          width: '100%', 
          margin: 0
        },
        '& .MuiBackdrop-root': {
          transition: 'opacity 0.3s ease-out',
        }

      }}
      slotProps={{
        backdrop: {
          ref: backdropRef as React.RefObject<HTMLDivElement>
        }
      }}
    >
      <div className="h-full flex flex-col">
        {/* Header with fixed position */}
        <div className="sticky top-0 z-10 bg-white w-full flex flex-row items-center border-b border-gray-200 my-1">
          <IconButton onClick={animateClose} className="p-3">
            <Close sx={{ fontSize: '1.75rem', color: '#000' }} />
          </IconButton>
          
          <div className="text-lg font-bold flex-grow text-center mr-12">
            {title}
          </div>
        </div>
        
        {/* Scrollable content */}
        <div className="flex-grow overflow-auto">
          {children}
        </div>
      </div>
    </Dialog>
  );
};
